import React from "react";

export default function PlanSection(props) {
  return (
    <div className="plans-sections">
      <div className="container-fluid">
        <div className="row">
          <div className="title-section">
            <h1>
             {props?.planSection?.content?.header[0]?.headline}
            </h1>
          </div>
        </div>
        <div className="row m-auto">
          {props?.planSection?.content?.cards?.map((items) => {
            return (
              <>
                <div className="icon col-md-3 col-lg-3" key={items?._uid}>
                  <img src={items?.icon_image?.filename} alt={items?.icon_image?.alt} />
                  <div className="plans-text">{items?.title_text}</div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
}
